import { render, staticRenderFns } from "./CustomStyles.vue?vue&type=template&id=54ef6017&"
import script from "./CustomStyles.vue?vue&type=script&lang=js&"
export * from "./CustomStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports